import Icon from '../../components/Icon.vue'

Icon.register({
  'regular/grin-stars': {
    width: 496,
    height: 512,
    paths: [
      {
        d: 'M248 8c137 0 248 111 248 248s-111 248-248 248-248-111-248-248 111-248 248-248zM248 456c110.3 0 200-89.7 200-200s-89.7-200-200-200-200 89.7-200 200 89.7 200 200 200zM353.6 304.6c10-3.1 19.3 5.5 17.7 15.3-8 47.1-71.3 80-123.3 80s-115.4-32.8-123.3-80c-1.7-10 7.9-18.4 17.7-15.3 26 8.3 64.4 13.1 105.6 13.1s79.7-4.8 105.6-13.1zM125.7 247.1l6.1-34.9-25.4-24.6c-4.6-4.6-1.9-12.3 4.3-13.2l34.9-5 15.5-31.6c2.9-5.8 11-5.8 13.9 0l15.5 31.6 34.9 5c6.2 1 8.8 8.7 4.3 13.2l-25.4 24.6 6 34.9c1 6.2-5.4 11-11 7.9l-31.3-16.3-31.3 16.3c-5.6 3.1-12-1.7-11-7.9zM385.4 174.4c6.2 1 8.9 8.6 4.4 13.2l-25.4 24.6 6 34.9c1 6.2-5.4 11-11 7.9l-31.3-16.3-31.3 16.3c-5.6 3.1-12-1.7-11-7.9l6-34.9-25.4-24.6c-4.6-4.6-1.9-12.3 4.3-13.2l34.9-5 15.5-31.6c2.9-5.8 11-5.8 13.9 0l15.5 31.6z'
      }
    ]
  }
})
